import(/* webpackMode: "eager" */ "/app/app/(auth)/forgot-password/page.tsx");
